/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
type DevelopmentEnquiry_development$ref = any;
export type DevelopmentRegistrationType = "complete_registration" | "normal_enquiry";
import type { FragmentReference } from "relay-runtime";
declare export opaque type DevelopmentActionBar_development$ref: FragmentReference;
declare export opaque type DevelopmentActionBar_development$fragmentType: DevelopmentActionBar_development$ref;
export type DevelopmentActionBar_development = {|
  +id: string,
  +registrationType: DevelopmentRegistrationType,
  +currentUserRegistrationForm: ?{|
    +id: string,
    +completed: boolean,
  |},
  +$fragmentRefs: DevelopmentEnquiry_development$ref,
  +$refType: DevelopmentActionBar_development$ref,
|};
export type DevelopmentActionBar_development$data = DevelopmentActionBar_development;
export type DevelopmentActionBar_development$key = {
  +$data?: DevelopmentActionBar_development$data,
  +$fragmentRefs: DevelopmentActionBar_development$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentActionBar_development",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "registrationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DevelopmentRegistrationForm",
      "kind": "LinkedField",
      "name": "currentUserRegistrationForm",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "completed",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentEnquiry_development"
    }
  ],
  "type": "DevelopmentProduct",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '39afbda8e3e00fa2396d4dcaf14fdd48';

export default node;
